
const config = {
   //API_BASE_URL: 'http://tse-consultant-int-app.runasp.net/api',
   API_BASE_URL: '/api',
    
    
    REQUEST_TIMEOUT: 30000,
    
    DEFAULT_HEADERS: {
      'Content-Type': 'application/json',
    },
  };
  
  export default config;